var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default"),(_vm.lastPage.total)?_c('div',{staticClass:"bottom"},[_vm._v("---------- "),_c('span',[_vm._v("没有更多数据了")]),_vm._v(" ----------")]):_vm._e(),(!_vm.lastPage.total)?_c('div',{staticClass:"loading"},[_vm._v("上拉加载中")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }